export default function(value, length, windowLength){
	const vContext = length * 0.01
	const v = value / vContext
	return Math.floor(v * 0.01 * windowLength * 100) / 100
}